module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "card",
    class: _vm.getCreativePreviewCardClasses
  }, [_vm._m(0), _c('div', {
    staticClass: "facebook-header"
  }, [_c('img', {
    staticClass: "profile-picture",
    attrs: {
      "src": _vm.resultFacebookPage.picture
    }
  }), _c('div', {
    staticClass: "middle"
  }, [_c('div', [_c('a', {
    staticClass: "fb-page-link",
    attrs: {
      "href": _vm.resultFacebookPage.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.resultFacebookPage.name))]), (_vm.goalType.isOffer) ? [_vm._v(" " + _vm._s(_vm.$t('pos.postPreview.offer.shared-an')) + " " + _vm._s(' ')), _c('a', {
    staticClass: "offer-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.offer')))])] : _vm._e()], 2), _c('div', {
    staticClass: "sponsored"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.sponsored')) + " " + _vm._s(' · ')), _c('div', {
    staticClass: "globe-icon"
  })])])]), _c('div', {
    staticClass: "promote-text"
  }, _vm._l((_vm.groupedMessageByLines), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })), (_vm.isType("image", "slideshow", "video")) ? _c('div', {
    staticClass: "file-preview"
  }, [_c('div', {
    staticClass: "file-container"
  }, [(_vm.isType("image")) ? [(_vm.resultCreative.media.length > 0) ? _c('image-helper', {
    attrs: {
      "src": _vm.isGif(_vm.resultCreative.media[0].path) ? _vm.resultCreative.media[0].path : _vm.resultCreative.media[0].thumbnail
    }
  }) : _c('image-helper', {
    attrs: {
      "src": _vm.defaultImage
    }
  })] : (_vm.isType("slideshow")) ? [(_vm.creative.media.length > 0) ? [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.resultCreative.media), function(picture, key) {
    return (_vm.currentSlide === key) ? _c('image-helper', {
      key: key,
      staticClass: "slideshow-image",
      attrs: {
        "src": picture.thumbnail
      }
    }) : _vm._e()
  }))] : _c('image-helper', {
    attrs: {
      "src": _vm.defaultImage
    }
  })] : (_vm.isType("video")) ? [(_vm.creative.media.length > 0) ? [(_vm.showVideo(_vm.resultCreative.media[0])) ? [_c('video', {
    attrs: {
      "controls": "controls"
    },
    on: {
      "load": function($event) {
        _vm.onImageLoaded()
      }
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.resultCreative.media[0].path
    }
  })])] : [_c('image-helper', {
    attrs: {
      "src": _vm.isGif(_vm.resultCreative.media[0].path) ? _vm.resultCreative.media[0].path : _vm.resultCreative.media[0].thumbnail
    }
  })]] : [_c('image-helper', {
    attrs: {
      "src": _vm.defaultImage
    },
    on: {
      "load": _vm.onImageLoaded
    }
  })]] : _vm._e()], 2), _c('div', {
    staticClass: "card-body",
    class: {
      'offer': _vm.goalType.isOffer && _vm.internalMobilePreview
    }
  }, [_c('div', [_c('div', {
    staticClass: "display-url-container"
  }, [_c('div', {
    staticClass: "display-url"
  }, [_vm._v(_vm._s(_vm.resultCreative.caption))])]), _c('h5', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.resultCreative.name))]), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.resultCreative.description))]), (_vm.isCtaVisible) ? _c('b-btn', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.toggleAdFormModal
    }
  }, [_vm._v(_vm._s(_vm.$t('fn.complex.calltoaction', {
    calltoaction: _vm.resultCreative.cta
  })))]) : _vm._e()], 1), _c('div', {
    staticClass: "display-url-container d-none"
  }, [(!_vm.goalType.isOffer || !_vm.internalMobilePreview) ? _c('div', {
    staticClass: "display-url"
  }, [_c('span', [_vm._v(_vm._s(_vm.resultCreative.caption))])]) : _vm._e(), (_vm.isCtaVisible) ? _c('b-btn', {
    staticClass: "cta-btn",
    on: {
      "click": _vm.toggleAdFormModal
    }
  }, [_vm._v(_vm._s(_vm.$t('fn.complex.calltoaction', {
    calltoaction: _vm.resultCreative.cta
  })))]) : _vm._e()], 1), (_vm.resultCreative.code_type === "one") ? _c('div', {
    staticClass: "offer-code"
  }, [_c('hr'), _c('span', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.resultCreative.code))]), _c('span', {
    staticClass: "offer-checkout"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.use-this-code-at-checkout')))])]) : _vm._e()])]) : _c('carousel', {
    ref: "carousel",
    attrs: {
      "pictures": _vm.resultCreative,
      "mobileView": _vm.internalMobilePreview,
      "defaultImage": _vm.defaultImage,
      "facebookPage": _vm.resultFacebookPage,
      "landingPage": _vm.resultLandingPage,
      "isCtaVisible": _vm.isCtaVisible,
      "isTimeline": _vm.isTimeline
    },
    on: {
      "ctaClick": _vm.toggleAdFormModal
    }
  }), (_vm.isType("carousel") && _vm.resultCreative.code_type === "one") ? _c('div', {
    staticClass: "offer-code mt-2"
  }, [_c('span', {
    staticClass: "code"
  }, [_vm._v(_vm._s(_vm.resultCreative.code))]), _c('span', {
    staticClass: "offer-checkout"
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.use-this-code-at-checkout')))])]) : _vm._e()], 1), (_vm.enableFormPreview) ? [(_vm.goalType.isOffer) ? [_c('b-btn', {
    staticClass: "offer-modal-button",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.toggleAdFormModal
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.offer.click-to-open')))]), (_vm.usePortal) ? _c('portal', {
    attrs: {
      "to": "creativePreviewModalPortal"
    }
  }, [_c('b-modal', {
    ref: "offer-form-modal",
    attrs: {
      "id": ("offerFormModal-" + (_vm.creative.id)),
      "body-class": "bg-light",
      "title": _vm.$t('pos.postPreview.offer.title')
    }
  }, [_c('offer-form-preview', {
    attrs: {
      "creative": _vm.resultCreative
    }
  })], 1)], 1) : [_c('b-modal', {
    ref: "offer-form-modal",
    attrs: {
      "id": ("offerFormModal-" + (_vm.creative.id)),
      "body-class": "bg-light",
      "title": _vm.$t('pos.postPreview.offer.title')
    }
  }, [_c('offer-form-preview', {
    attrs: {
      "creative": _vm.resultCreative
    }
  })], 1)]] : _vm._e(), (_vm.goalType.isLead && _vm.defaultLeadConfig) ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    staticClass: "lead-modal-button",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.toggleAdFormModal
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.postPreview.lead-form.click-to-open')))]), (_vm.usePortal) ? _c('portal', {
    attrs: {
      "to": "creativePreviewModalPortal"
    }
  }, [_c('b-modal', {
    ref: "lead-form-modal",
    attrs: {
      "id": ("leadFormModal-" + (_vm.creative.id)),
      "size": "md",
      "title": _vm.$t('pos.postPreview.lead-form.title')
    },
    on: {
      "shown": function($event) {
        _vm.$refs['lead-form-preview'].triggerUpdate()
      }
    }
  }, [_c('lead-form-preview', {
    ref: "lead-form-preview",
    staticClass: "form-preview",
    attrs: {
      "facebookPage": _vm.facebookPage,
      "headerImage": _vm.leadFormThumbnail,
      "question": _vm.customQuestion,
      "inputFields": _vm.defaultLeadConfig.user_data
    }
  })], 1)], 1) : [_c('b-modal', {
    ref: "lead-form-modal",
    attrs: {
      "id": ("leadFormModal-" + (_vm.creative.id)),
      "size": "md",
      "title": _vm.$t('pos.postPreview.lead-form.title')
    },
    on: {
      "shown": function($event) {
        _vm.$refs['lead-form-preview'].triggerUpdate()
      }
    }
  }, [_c('lead-form-preview', {
    ref: "lead-form-preview",
    staticClass: "form-preview",
    attrs: {
      "facebookPage": _vm.facebookPage,
      "headerImage": _vm.leadFormThumbnail,
      "question": _vm.customQuestion,
      "inputFields": _vm.defaultLeadConfig.user_data
    }
  })], 1)]], 2) : _vm._e()] : _vm._e(), (!_vm.disabledButtons) ? _c('div', {
    staticClass: "row switcher"
  }, [(_vm.showCreativeIdBottom) ? _c('div', {
    staticClass: "col form-creative-id"
  }, [_vm._v(_vm._s(("ID " + (_vm.creative.id))))]) : _vm._e(), _c('div', {
    staticClass: "col format-switcher",
    class: _vm.internalMobilePreview ? 'mobile' : 'desktop'
  }, [_c('div', {
    staticClass: "button button-mobile",
    attrs: {
      "slot": "button-next"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.icons.getCreativePreview("mobile"))
    },
    on: {
      "click": function($event) {
        _vm.setMobilePreview(true)
      }
    },
    slot: "button-next"
  }), _c('div', {
    staticClass: "button button-desktop",
    attrs: {
      "slot": "button-next"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.icons.getCreativePreview("desktop"))
    },
    on: {
      "click": function($event) {
        _vm.setMobilePreview(false)
      }
    },
    slot: "button-next"
  })])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-actions-header"
  }, [_c('div', {
    staticClass: "more-actions-block"
  }, [_c('div', {
    staticClass: "more-actions-button"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b87e3b4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/creative-preview/CreativePreview.vue
// module id = 2050
// module chunks = 1